import CurrencyConverter from 'shopify-currency-converter';

export default class PriceUpdater {
  constructor() {
    this.theme = window.Theme;
    this.moneyFormat = this.theme.currency.moneyFormat;
  }

  updatePrice($el, price) {
    // Assign base shop based currency to data attributes and text
    const formattedPrice = window.Shopify.formatMoney(price, this.moneyFormat);
    $el.text(formattedPrice);

    if (this.theme.currency.enable && window.Currency) {
      CurrencyConverter.update($el[0]);
    }
  }
}
